const currencyFormat = (number, hideCentsIfZero = false, shopCurrency = "eur") => {
	let curr = "€";
	if (shopCurrency == "CHF") curr = "CHF";
	const [currency, cents] = Number(number).toFixed(2).toString().split(".");
	if (hideCentsIfZero && cents == 0) {
		return `${currency.replace(/\B(?=(\d{3})+(?!\d))/g, ".")} ` + curr;
	} else {
		return `${currency.replace(/\B(?=(\d{3})+(?!\d))/g, ".")},${cents} ` + curr;
	}
};

export function replaceAll(str, find, replace) {
	return str.replace(new RegExp(find, "g"), replace);
}

export function cutString(string, maxLength) {
	if (string.length > maxLength) {
		var trimmedString = string.substr(0, maxLength);
		trimmedString = trimmedString.substr(
			0,
			Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))
		);
		return trimmedString + "...";
	} else return string;
}

export const getStatusLabel = (status) => {
	if (status == "confirmed") status = 77;
	if (status == "filled") status = 78;
	if (status == "archived") status = 79;
	if (status == "cancel_request") status = 80;
	if (status == "ready") status = 81;
	if (status == "preparation") status = 82;
	if (status == "unconfirmed") status = 83;
	return status;
};

export const getStatusColor = (status) => {
	if (status == "unconfirmed") status = "#fbb02d";
	if (status == "confirmed") status = "#d9ffdb";
	if (status == "preparation") status = "#cbc5ea";
	if (status == "ready") status = "#73628a";
	if (status == "filled") status = "#deffff";
	if (status == "archived") status = "#bf0426";
	if (status == "cancel_request") status = "#822e81";
	return status;
};

export const getTranslatedString = (obj, name, lang) => {
	if (obj["translations"] && obj["translations"][lang] && obj["translations"][lang][name])
		return obj["translations"][lang][name];
	if (lang && lang !== "it" && obj[name + "_" + lang])
		return obj[name + "_" + lang];
	return obj[name];
};

export const textLabel = (labels, number, lang) => {
	if (labels) {
		let l = labels.filter((l) => {
			return l.id === number;
		});
		if (l.length > 0) return l[0][lang];
	}
};

export const getVisibleCartView = (cart, settings) => {
	const products = cart?.products || [];

	if (settings?.selfordering?.hide_covers_before_product != 1) {
		return { products, total: cart?.total, total_items: cart?.total_items };
	}

	const hasRealProduct = products.some((p) => !p.is_cover && !p.is_service);
	if (hasRealProduct) {
		return { products, total: cart?.total, total_items: cart?.total_items };
	}

	const hiddenItems = products.filter((p) => p.is_cover || p.is_service);
	const hiddenTotal = hiddenItems.reduce((sum, p) => sum + p.price * p.qty, 0);
	const hiddenQty = hiddenItems.reduce((sum, p) => sum + p.qty, 0);

	return {
		products: products.filter((p) => !p.is_cover && !p.is_service),
		total: (cart?.total || 0) - hiddenTotal,
		total_items: (cart?.total_items || 0) - hiddenQty,
	};
};

export default currencyFormat;
